import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import rolePower from './comp/power.vue';
import utilRules from '@/libs/rules';
import md5 from 'md5';
var rule = [{
  key: 'accountName',
  name: '员工姓名'
}, {
  key: 'loginAccount',
  name: '登录账号'
}, // { key: 'accountPassword', name: '登录密码' },
{
  key: 'accountPhone',
  name: '电话',
  validator: 'validatePhone'
}, {
  key: 'positionId',
  name: '角色'
}, {
  key: 'departmentId',
  name: '部门'
}];
var initForm = {
  accountName: '',
  loginAccount: '',
  accountPassword: '',
  accountPhone: '',
  positionId: '',
  departmentId: '',
  positionAuthorities: []
};
import { cloneDeep } from 'lodash';
export default {
  meta: {
    title: '编辑员工',
    auth: true,
    authorityValue: 'store-account-management'
  },
  name: 'editStaff',
  components: {
    rolePower: rolePower
  },
  data: function data() {
    return {
      // 表单
      formData: cloneDeep(initForm),
      rules: utilRules(rule),
      buMenOptions: [],
      roleOptions: [],
      props: {
        value: 'departmentId',
        label: 'departmentName',
        checkStrictly: true
      },
      password: '*********',
      edit: false
    };
  },
  created: function created() {
    this.dataBind();
  },
  computed: {
    VUE_APP_LOGIN_SALT: function VUE_APP_LOGIN_SALT() {
      return process.env.VUE_APP_LOGIN_SALT;
    }
  },
  methods: {
    changeRadio: function changeRadio(e) {
      var item = this.roleOptions.find(function (v) {
        return v.positionId === e;
      });
      var rolePower = this.$refs.rolePower;
      rolePower.emitSetRole(item.positionAuthorities);
    },
    handleChange: function handleChange(e) {
      console.log('e', e);
    },
    staffDetails: function staffDetails(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, obj;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.staffDetails(item);

              case 2:
                data = _context.sent;
                obj = cloneDeep(data);

                _this.$refs.rolePower.emitRoleLost(obj.positionAuthorities);

                _this.formData = obj;

                _this.$set(_this.formData, 'departmentId', YL.getTreeId(_this.buMenOptions, data.departmentId, {
                  keyId: 'departmentId'
                }));

                console.log(YL.getTreeId(_this.buMenOptions, data.departmentId, {
                  keyId: 'departmentId'
                }));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataBind: function dataBind(item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var query, data, _yield$_this2$$api$po, records;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                query = _this2.$route.query; //部门

                _context2.next = 3;
                return _this2.$api.departments();

              case 3:
                data = _context2.sent;
                _this2.buMenOptions = data; //角色

                _context2.next = 7;
                return _this2.$api.positions({
                  pageSize: 999
                });

              case 7:
                _yield$_this2$$api$po = _context2.sent;
                records = _yield$_this2$$api$po.records;
                _this2.roleOptions = records;

                _this2.staffDetails(query);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log('1111', _this3.formData); // return

                _this3.$refs.formData.validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
                    var roleList, params;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!valid) {
                              _context3.next = 18;
                              break;
                            }

                            roleList = _this3.$refs.rolePower.emitRole();
                            params = cloneDeep(_this3.formData);
                            _context3.t0 = Object;
                            _context3.t1 = params;
                            _context3.next = 7;
                            return _this3.confirm(roleList);

                          case 7:
                            _context3.t2 = _context3.sent;
                            params = _context3.t0.assign.call(_context3.t0, _context3.t1, _context3.t2);
                            params.departmentId = params.departmentId[params.departmentId.length - 1];

                            if (!(_this3.edit && !params.accountPassword)) {
                              _context3.next = 12;
                              break;
                            }

                            return _context3.abrupt("return", YL.message('请填写密码', 'error'));

                          case 12:
                            if (_this3.edit && params.accountPassword) {
                              _this3.$set(params, 'accountPassword', md5("".concat(params.accountPassword).concat(_this3.VUE_APP_LOGIN_SALT)));
                            }

                            if (!_this3.edit) {
                              delete params.accountPassword;
                            }

                            _context3.next = 16;
                            return _this3.$api.saveStaff(_objectSpread(_objectSpread({}, params), _this3.$route.query));

                          case 16:
                            _this3.$notify.success({
                              title: '成功',
                              message: '修改成功'
                            });

                            _this3.goBack();

                          case 18:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    confirm: function confirm(roleList) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var params, data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                params = {
                  positionAuthorities: []
                };
                data = cloneDeep(roleList);
                data.forEach(function (v) {
                  var positionLen = v.positionAuthorities.length;

                  if (positionLen > 0) {
                    v.active = true;
                    v.children = v.children.map(function (k) {
                      if (v.positionAuthorities.includes(k.authorityValue)) {
                        return _objectSpread(_objectSpread({}, k), {}, {
                          active: true
                        });
                      } else {
                        return _objectSpread(_objectSpread({}, k), {}, {
                          active: false
                        });
                      }
                    });
                    params.positionAuthorities.push(v);
                  } else {
                    if (v.check) v.active = v.check;
                    v.children = v.children.map(function (k) {
                      return _objectSpread(_objectSpread({}, k), {}, {
                        active: false
                      });
                    });
                    params.positionAuthorities.push(v);
                  }
                });
                return _context5.abrupt("return", params);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  }
};